exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-mask[data-v-4bf130dc]{position:fixed;z-index:9998;top:0;left:0;right:0;bottom:0;background-color:rgba(0,0,0,.5);display:flex;align-items:center;justify-content:center}.modal-wrapper[data-v-4bf130dc]{width:400px;background:#fff;padding:20px;border-radius:6px}", ""]);

// exports
